export default "__VITE_ASSET__DPFsdVA2__"